import React, { useState, useEffect } from 'react'
import { Box, Grid, Card, Flex, Text, Button, Badge, Skeleton, SimpleGrid, Drawer } from '@mantine/core'
import { useSelector } from 'react-redux'
import { getAllProvinceList, getAllCityList } from '../../../../services/location'
import FormAdjustAdditionalInfo from './Form/FormAdjustAdditionalInfo'


const OrderAdditionalInfo = () => {
  const { isLoadingOrder, additionalInfo } = useSelector(state => state.order_detail)
  const [loadingProvince, setLoadingProvince] = useState(true)
  const [loadingCity, setLoadingCity] = useState(true)
  const [provinceName, setProvinceName] = useState('')
  const [cityName, setCityName] = useState('')
  const [openModalForm, setOpenModalForm] = useState(false)

  const handleGetProvinceName = async (provinceId) => {
    setLoadingProvince(true)
    const params = {
      'filter[id][is]' : provinceId,
      'fields[provinces]': 'name',
    }
    try {
      const response = await getAllProvinceList(params)
      if (response.success) {
        const dataProvince = response.data
        if (dataProvince.length > 0) {
          setProvinceName(dataProvince[0].attributes.name)
        } else {
          setProvinceName('-')
        }
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingProvince(false)
    }
  }

  const handleGetCityName = async (cityId) => {
    setLoadingCity(true)
    const params = {
      'filter[id][is]' : cityId,
      'fields[cities]': 'name',
    }
    try {
      const response = await getAllCityList(params)
      if (response.success) {
        const dataCity = response.data
        if (dataCity.length > 0) {
          setCityName(dataCity[0].attributes.name)
        } else {
          setCityName('-')
        }
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingCity(false)
    }
  }

  useEffect(() => {
    if (!isLoadingOrder) {
      if (additionalInfo.origin_province) {
        handleGetProvinceName(additionalInfo.origin_province)
      } else {
        setLoadingProvince(false)
        setProvinceName('-')
      }
      if (additionalInfo.origin_city) {
        handleGetCityName(additionalInfo.origin_city)
      } else {
        setLoadingCity(false)
        setCityName('-')
      }
    }
  }, [isLoadingOrder, additionalInfo])

  
  const onCloseModalForm = () => {
    setOpenModalForm(false)
  }
  return (
    <Box>
      <Box my={20}>
        <Grid align='start' overflow='hidden'>
          <Grid.Col span={6}>
            <Card withBorder shadow="xs" radius="md" padding='md'>
              <Card.Section withBorder inheritPadding py="xs">
                <Flex justify='flex-end' align='center'>
                  <Button size='compact-xs' variant="outline" color='black' onClick={() => setOpenModalForm(true)}>Edit</Button>
                </Flex>
              </Card.Section>
              <Card.Section withBorder inheritPadding py='md'>
                <SimpleGrid cols={2} verticalSpacing="sm" mb='sm'>
                  <Box mb='md'>
                    <Text fz={12} c='gray.6' mb={4}>Marking Code</Text>
                    <Text fz={12} c='black' fw='600'>{!isLoadingOrder ? additionalInfo.marking_code || '-' : '-'}</Text>
                  </Box>
                  <Box mb='md'>
                    <Text fz={12} c='gray.6' mb={4}>Supplier Name</Text>
                    <Text fz={12} c='black' fw='600'>{!isLoadingOrder ? additionalInfo.supplier_name || '-' : '-'}</Text>
                  </Box>
                  <Box>
                    <Box mb='md'>
                      <Text fz={12} c='gray.6' mb={4}>Origin Country</Text>
                      <Badge variant="light" color='black' tt='capitalize' fw='500' mb={4}>{!isLoadingOrder ? additionalInfo.origin : <Skeleton width={100} height={16} radius="xl" />}</Badge>
                    </Box>
                    <Box mb='md'>
                      <Text fz={12} c='gray.6' mb={4}>Origin Province</Text>
                      <Text fz={12} c='black' fw='600'>{!loadingProvince ? provinceName : <Skeleton width={100} height={16} radius="xl" />}</Text>
                    </Box>
                    <Box mb='md'>
                      <Text fz={12} c='gray.6' mb={4}>Origin City</Text>
                      <Text fz={12} c='black' fw='600'>{!loadingCity ? cityName : <Skeleton width={100} height={16} radius="xl" />}</Text>
                    </Box>
                    <Box mb='md'>
                      <Text fz={12} c='gray.6' mb={4}>Origin Address</Text>
                      <Text fz={12} c='black' fw='600'>{!isLoadingOrder ? additionalInfo.origin_address || '-' : '-'}</Text>
                    </Box>
                  </Box>
                  <Box>
                  <Box mb='md'>
                    <Text fz={12} c='gray.6' mb={4}>Destination</Text>
                    <Badge variant="light" color='black' tt='capitalize' fw='500' mb={4}>{!isLoadingOrder ? additionalInfo.destination : <Skeleton width={100} height={16} radius="xl" />}</Badge>
                  </Box>
                  </Box>
                </SimpleGrid>
              </Card.Section>
            </Card>
          </Grid.Col>
        </Grid>
      </Box>
      <Drawer position='right' title='Update additional info' opened={openModalForm} onClose={onCloseModalForm} overlayProps={{ backgroundOpacity: 0.5, blur: 4 }}>
        <FormAdjustAdditionalInfo onCloseForm={onCloseModalForm} />
      </Drawer>
    </Box>
    
  )
}

export default OrderAdditionalInfo